import { getOpaqueBatchEventProcessor, wrapEventProcessor, getForwardingEventProcessor, getPrefixEventStore, } from './event_processor_factory';
import defaultEventDispatcher from './event_dispatcher/default_dispatcher.browser';
import sendBeaconEventDispatcher from './event_dispatcher/send_beacon_dispatcher.browser';
import { LocalStorageCache } from '../utils/cache/local_storage_cache.browser';
import { FAILED_EVENT_RETRY_INTERVAL } from './event_processor_factory';
import { DEFAULT_MAX_EVENTS_IN_STORE, EventStore } from './event_store';
export const DEFAULT_EVENT_BATCH_SIZE = 10;
export const DEFAULT_EVENT_FLUSH_INTERVAL = 1000;
export const EVENT_MAX_RETRIES_BROWSER = 2;
export const createForwardingEventProcessor = (eventDispatcher = defaultEventDispatcher) => {
    return wrapEventProcessor(getForwardingEventProcessor(eventDispatcher));
};
export const createBatchEventProcessor = (options = {}) => {
    var _a;
    const eventStore = options.eventStore ? getPrefixEventStore(options.eventStore) : new EventStore({
        store: new LocalStorageCache(),
        maxSize: options.batchSize ? Math.max(options.batchSize * 2, DEFAULT_MAX_EVENTS_IN_STORE)
            : DEFAULT_MAX_EVENTS_IN_STORE,
        ttl: options.storeTtl,
    });
    return getOpaqueBatchEventProcessor({
        eventDispatcher: options.eventDispatcher || defaultEventDispatcher,
        closingEventDispatcher: options.closingEventDispatcher ||
            (options.eventDispatcher ? undefined : sendBeaconEventDispatcher),
        flushInterval: options.flushInterval,
        batchSize: options.batchSize,
        defaultFlushInterval: DEFAULT_EVENT_FLUSH_INTERVAL,
        defaultBatchSize: DEFAULT_EVENT_BATCH_SIZE,
        retryOptions: {
            maxRetries: (_a = options.maxRetries) !== null && _a !== void 0 ? _a : EVENT_MAX_RETRIES_BROWSER,
        },
        failedEventRetryInterval: FAILED_EVENT_RETRY_INTERVAL,
        eventStore,
        storeTtl: options.storeTtl,
    });
};
export const __platforms = ['browser'];
//# sourceMappingURL=event_processor_factory.browser.js.map